<template>
    <div class="container-fluid bg-white sticky-top" id="header-bat">
        <!-- Header Desktop -->
        <div class="container py-3 d-none d-xl-block">
            <div class="row d-flex justify-content-center align-items-center">
                <div class="col-2 d-flex justify-content-center">
                    <a href="/home-bat">
                        <img v-if="!isStaffUser" class="img-logo-header" :src="buscarSegmento(client_segment) ? '/img/brand/logo_header_contigo_new.svg' : '/img/brand/logo_header_new.svg'" alt="logo-conectados">
                        <img v-if="isStaffUser" class="img-logo-header" src="/img/icons/Logo_Staff.svg" alt="">
                    </a>
                </div>
                <div class="col-6">
                    <nav>
                        <ul class="d-flex justify-content-center align-items-center list-inline mb-0 text-bat">
                            <li class="mx-3 item-menu-desktop">
                                <a class="text-decoration-none" id="header-inicio" title="inicio" href="/home-bat" :class="{ 'text-title-bat text-indigo': isActive('/home-bat'), 'text-dark': !isActive('/home-bat') }" @click="setActive('/home-bat')">Inicio</a>
                            </li>

                            <li id="pedido-tour-header" class="mx-3 item-menu-desktop" v-if="segments_show_web_ordering.includes(client_segment) && pdvs_web_ordering.length > 0">
                                <el-dropdown v-if="isStaffUser && pdvs_web_ordering.length > 1" @command="handleCommand">
                                    <a class="el-dropdown-link text-decoration-none" :class="{ 'text-title-bat text-indigo': isActive('/pedidos'), 'text-dark': !isActive('/pedidos') }" @click="setActive('/pedidos')">
                                        Hacer pedido
                                        <i class="el-icon-arrow-down el-icon--right"></i>
                                    </a>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item v-for="pdv in pdvs_web_ordering" :key="pdv.id" :command="pdv.id">
                                            <div class="pdv-item-menu">
                                                <div class="pdv-name-menu">{{ truncateText(formatName(pdv.name_pdv), 35) }}</div>
                                                <div class="pdv-address-menu">
                                                    <img src="/img-version2/icons/staff/location.svg" alt="location" />
                                                    {{ truncateText(pdv.address_pdv, 35) }}
                                                </div>
                                            </div>
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>

                                <a v-else class="text-decoration-none" href="/pedidos" :class="{ 'text-title-bat text-indigo': isActive('/pedidos'), 'text-dark': !isActive('/pedidos') }" @click="setActive('/pedidos')">
                                    Hacer pedido
                                </a>
                            </li>
                            <li id="winpoints-vue-header" class="mx-3 item-menu-desktop">
                                <a class="text-decoration-none" id="header-gana-puntos" title="gana puntos" href="/retos" :class="{ 'text-title-bat text-indigo': isActive('/retos'), 'text-dark': !isActive('/retos') }" @click="setActive('/retos')">Gana puntos</a>
                            </li>
                            <li id="canjea-tour-header" class="mx-3 item-menu-desktop">
                                <a class="text-decoration-none" id="header-canjea" title="canjea" href="/catalogo" :class="{ 'text-title-bat text-indigo': isActive('/catalogo'), 'text-dark': !isActive('/catalogo') }" @click="setActive('/catalogo')">Canjea</a>
                            </li>
                            <li id="staff-tour-header" v-if="client_segment === 14" class="mx-3 item-menu-desktop position-relative">
                                <a class="text-decoration-none" id="header-staff" title="staff" href="/get-pdvs-request-manager" :class="{ 'text-title-bat text-indigo': isActive('/solicitudes'), 'text-dark': !isActive('/solicitudes') }" @click="setActive('/solicitudes')">Solicitudes</a>
                                <span v-if="showRedDotRequest >= 1" class="position-absolute top-0 start-100 translate-middle rounded-circle bg-danger fs-8"
                                    style="width: 10px; height: 10px;">
                                </span>
                            </li>
                            <li v-if="client_segment != 10" class="mx-3 item-menu-desktop hide-informados">
                                <a class="text-decoration-none" href="/novedades" :class="{ 'text-title-bat text-indigo': isActive('/novedades'), 'text-dark': !isActive('/novedades') }"
                                    @click="setActive('/novedades')">Informados</a>
                            </li>
                        </ul>
                    </nav>
                </div>
                <!-- Racha segmento staff -->
                <div class="col-2" v-if="isStaffUser">
                    <div class="d-flex align-items-center gap-1">
                        <!-- Racha -->
                        <div class="streak-box position-relative d-flex align-items-center ps-4 pe-3 py-1 cursor-pointer" v-if="activeSeason != null && isStaffUser" @click="showSeasonModal = true">
                            <img :src="getStaffSeasonImage" alt="Icon racha"  class="streak-icon-header-staff position-absolute translate-middle-y" />
                            <strong class="ms-1">Racha {{ lapse_active }}</strong>
                        </div>

                        <!-- Puntos -->
                        <div class="points-box d-flex align-items-center px-2 py-1 cursor-pointer" @click="goToCanjea()">
                            <strong class="me-1">{{ userPoints }}</strong> Pts
                        </div>
                    </div>
                </div>

                <!-- Racha otros segmentos -->
                <div class="col-2" v-if="!isStaffUser" >
                    <div class="d-flex justify-content-center">
                        <span class="box-season-header cursor-pointer" v-if="activeSeason != null">
                            <img :src="getSeasonImage" alt="Imagen de la temporada" @click="goToRetos">
                        </span>
                        <span class="box-points-header" >
                            <strong>
                                {{ userPoints }}
                            </strong>
                            Pts
                        </span>
                    </div>
                </div>
                <div class="col-2 position-relative">
                    <div class="row d-flex justify-content-center">
                        <!-- Carrito de compras -->
                        <div id="cart-vue-header" class="col-3 cursor-pointer">
                            <div class="position-relative" @click="activarShopCart()">
                                <img class="img-menu-fixed" src="/img/brand/cart_new_look.svg" alt="">
                                <span v-if="products_cart.length > 0" class="position-absolute top-0 start-50 ms-2 mt-1 translate-middle badge border border-light rounded-circle bg-danger px-1 fs-8">{{ products_cart.length }}</span>
                            </div>
                        </div>
                        <!-- Notificaciones -->
                        <div class="col-3 cursor-pointer">
                            <div v-if="resolution === 'lg' || resolution === 'xl'" class="position-relative">
                                <notifications></notifications>
                            </div>
                        </div>
                        <div class="col-3 d-flex justify-content-center align-items-center cursor-pointer" @click="toggleSubMenu()">
                            <img src="/img/brand/user_new_look.svg" alt="">
                            <img src="/img/icons/arrow-down-grey.svg" alt="">
                        </div>
                        <!-- Sub Menu Escritorio -->
                    </div>
                    <div class="subMenuDesktop position-absolute top-100 start-50 translate-middle" :class="{'d-block' : subMenuDesktopActive, 'd-none' : !subMenuDesktopActive}">
                        <a href="/mi-perfil" class="my-3 text-decoration-none text-bat text-dark d-flex justify-content-center align-items-center cursor-pointer">
                            <img class="img-menu-fixed me-2" src="/img/icons/user-profile-menu.svg">
                            <span>Mi perfil</span>
                        </a>
                        <div class="my-3">
                            <button  class="bg-transparent border-0 text-bat" @click="logout()">
                                <img class="img-menu-fixed" src="/img/icons/cerrar-sesion-menu.svg" alt="">
                                <span>Cerrar sesión</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Header Mobile -->
        <div class="container py-3 d-block d-xl-none">
            <div class="row">
                <div class="col-4 d-flex justify-content-center">
                    <a href="/home-bat">
                        <img v-if="!isStaffUser" class="img-logo-header" :src="buscarSegmento(client_segment) ? '/img/brand/logo_header_contigo_new.svg' : '/img/brand/logo_header_new.svg'"
                            alt="logo-conectados">
                        <img v-if="isStaffUser" class="img-logo-header" src="/img/icons/Logo_Staff.svg" alt="logo-conectados">
                    </a>
                </div>
                <!-- Racha segmento staff -->
                <div :class="{ 'justify-content-center': !isStaffUser }" class="col-6 d-flex " v-if="isStaffUser">
                    <div class="d-flex align-items-center gap-1">
                        <div class="streak-box position-relative d-flex align-items-center ps-4 pe-3 py-1 cursor-pointer" v-if="activeSeason != null && isStaffUser" @click="showSeasonModal = true">
                            <img :src="getStaffSeasonImage" alt="Icono racha" class="streak-icon-header-staff position-absolute translate-middle-y" />
                            <div class="ms-2">Racha {{ lapse_active }}</div>
                        </div>
                        <div class="points-box d-flex align-items-center px-1 py-1 cursor-pointer" @click="goToCanjea()">
                            <div class="me-1">{{ userPoints }}</div>Pts
                        </div>
                    </div>
                </div>
                <!-- Racha otros segmentos -->
                <div class="col-6 d-flex justify-content-center"  v-if="!isStaffUser" >
                    <div class="d-flex justify-content-center align-items-center">
                        <span class="box-season-header cursor-pointer" v-if="activeSeason != null">
                            <img :src="getSeasonImage" alt=""  @click="goToRetos">
                        </span>
                        <span class="box-points-header">
                            <strong class="fs-6">
                                {{ userPoints }}
                            </strong>
                            Pts
                        </span>
                    </div>
                </div>
                <!-- Notificaciones -->
                <div :class="{
                    'justify-content-center': !isStaffUser
                }" class="col-2 d-flex">
                    <div v-if="resolution === 'sm' || resolution === 'md'" class="position-relative">
                        <notifications></notifications>
                    </div>
                </div>
            </div>
        </div>
        <!-- Menu Fixed Mobile -->
        <div class="d-block d-xl-none">
            <div class="container-fluid fixed-bottom bg-white rounded-top py-2">
                <div class="row justify-content-between align-items-start">
                    <div class="col-2 d-flex flex-column justify-content-center cursor-pointer item-menu-mobile" :class="{ 'active' : this.route_view == '/home-bat'}">
                        <a id="menu-mobile-inicio" title="inicio"  @click="showView('/home-bat')" class="d-flex aling-items-center text-decoration-none flex-column" >
                            <div class="d-flex justify-content-center mx-auto aling-items-center" :class="{ 'active-menu-fixed-icon': isActive('/home-bat'), 'text-dark text-bat': !isActive('/home-bat') }">
                                <img class="mb-1 img-menu-fixed mx-auto" src="/img/icons/home-new-look.svg" alt="">
                            </div>
                            <span class="text-center fs-7" :class="{ 'text-title-bat text-indigo': isActive('/home-bat'), 'text-dark text-bat': !isActive('/home-bat') }" @click="setActive('/home-bat')">
                                Inicio
                            </span>
                        </a>
                    </div>
                    <div id="pedido-tour" class="col-2 d-flex flex-column justify-content-center item-menu-mobile" :class="{ 'active': this.route_view == '/pedidos' }"
                        v-if="segments_show_web_ordering.includes(client_segment) && pdvs_web_ordering.length > 0">

                        <a v-if="isStaffUser && pdvs_web_ordering.length > 1"
                           class="d-flex aling-items-center text-decoration-none flex-column" @click="pdvMobile = true">
                            <div class="d-flex justify-content-center mx-auto aling-items-center mb-1"
                                 :class="{ 'active-menu-fixed-icon mb-0': isActive('/pedidos'), 'text-dark text-bat': !isActive('/pedidos') }">
                                <img class="mb-1 img-menu-fixed mx-auto" src="/img/brand/cart_new_look.svg" alt="">
                            </div>
                            <span class="text-center fs-7 lh-1"
                                  :class="{ 'text-title-bat text-indigo': isActive('/pedidos'), 'text-dark text-bat': !isActive('/pedidos') }">
                                    Hacer Pedido
                                </span>
                        </a>


                        <a v-else class="d-flex aling-items-center text-decoration-none flex-column" @click="showView('/pedidos')">
                            <div class="d-flex justify-content-center mx-auto aling-items-center mb-1" :class="{ 'active-menu-fixed-icon mb-0': isActive('/pedidos'), 'text-dark text-bat': !isActive('/pedidos') }">
                                <img class="mb-1 img-menu-fixed mx-auto" src="/img/brand/cart_new_look.svg" alt="">
                            </div>
                            <span class="text-center fs-7 lh-1" :class="{ 'text-title-bat text-indigo': isActive('/pedidos'), 'text-dark text-bat': !isActive('/pedidos') }">
                                Hacer Pedido
                            </span>
                        </a>
                    </div>

                    <div id="winpoints-vue" class="col-2 d-flex flex-column justify-content-center item-menu-mobile" :class="{ 'active' : this.route_view == '/retos'}">
                        <a id="menu-mobile-gana-puntos" title="gana puntos" @click="showView('/retos')"
                            class="d-flex aling-items-center text-decoration-none flex-column">
                            <div class="d-flex justify-content-center mx-auto aling-items-center mb-1"
                                :class="{ 'active-menu-fixed-icon mb-0': isActive('/retos'), 'text-dark text-bat': !isActive('/retos')  }">
                                <img class="mb-1 img-menu-fixed mx-auto" src="/img/icons/gana_puntos_star.svg" alt="">
                            </div>
                            <span class="text-center fs-7 lh-1" :class="{ 'text-title-bat text-indigo': isActive('/retos'), 'text-dark text-bat': !isActive('/retos')  }" @click="setActive('/retos')">
                                Gana puntos
                            </span>
                        </a>
                    </div>
                    <div id="canjea-vue" class="col-2 d-flex flex-column justify-content-center item-menu-mobile"
                        :class="{ 'active': this.route_view == '/catalogo' }">
                        <a id="menu-mobile-canjea" title="canjea" @click="showView('/catalogo')"
                            class="d-flex aling-items-center text-decoration-none flex-column">
                            <div class="d-flex justify-content-center mx-auto aling-items-center"
                                :class="{ 'active-menu-fixed-icon': isActive('/catalogo'), 'text-dark text-bat': !isActive('/catalogo') }">
                                <img class="mb-1 img-menu-fixed mx-auto" src="/img/icons/canjea-menu.svg" alt="">
                            </div>
                            <span class="text-center fs-7"
                                :class="{ 'text-title-bat text-indigo': isActive('/catalogo'), 'text-dark text-bat': !isActive('/catalogo')  }"
                                @click="setActive('/catalogo')">
                                Canjea
                            </span>
                        </a>
                    </div>
                    <div id="staff-vue" v-if="client_segment === 14" class="col-2 d-flex flex-column justify-content-center item-menu-mobile" :class="{ 'active' : this.route_view == '/staff/solicitudes'}">
                        <a id="menu-mobile-staff" title="staff" @click="goToStaff" class="d-flex aling-items-center text-decoration-none flex-column" >
                            <div class="d-flex justify-content-center mx-auto aling-items-center position-relative" :class="{ 'active-menu-fixed-icon': isActive('/solicitudes'), 'text-dark text-bat': !isActive('/solicitudes')  }">
                                <img class="mb-1 img-menu-fixed mx-auto" src="/img-version2/icons/staff/notification-staff.svg" alt="">
                                <span v-if="showRedDotRequest >= 1" class="position-absolute top-0 start-100 translate-middle rounded-circle bg-danger fs-8" style="width: 10px; height: 10px;">
                                </span>
                            </div>
                            <span class="text-center fs-7" :class="{ 'text-title-bat text-indigo': isActive('/solicitudes'), 'text-dark text-bat': !isActive('/solicitudes')  }" @click="setActive('/solicitudes')">
                                Solicitudes
                            </span>

                        </a>
                    </div>
                    <div id="menutour-vue" class="col-2 d-flex flex-column justify-content-center" @click="activarMenu()">
                        <img class="mb-1 img-menu-fixed mx-auto" src="/img/icons/add-circle-menu.svg" alt="">
                        <span class="text-dark text-bat text-center fs-7">
                            Mas
                        </span>
                    </div>
                </div>
            </div>

        </div>
        <!-- Menu extendido Mobile-->
        <div class="d-block d-xl-none">
            <div class="menu-extendido" :class="{ 'active': menuMobileActive }" ref="menuExtendido">
                <div class="container py-3">
                    <div class="d-flex justify-content-center mb-3" @click="activarMenu()">
                        <img src="/img/icons/arrow-down-grey.svg" alt="">
                    </div>
                    <div class="d-flex align-items-center mb-4 item-submenu-mobile" @click="activarShopCart()">
                        <div class="position-relative">
                            <img class="img-menu-fixed" src="/img/brand/cart_new_look.svg" alt="">
                            <span v-if="products_cart.length > 0" class="position-absolute top-0 start-50 ms-2 mt-1 translate-middle badge border border-light rounded-circle bg-danger px-1 fs-8">{{
                                    products_cart.length }}</span>
                        </div>
                        <p class="ms-3 text-bat mb-0">
                            Carrito de canje
                        </p>
                    </div>
                    <div class="d-flex align-items-center mb-4 item-submenu-mobile" :class="{ 'active': this.route_view == '/mi-perfil'}">
                        <a class="d-flex aling-items-center text-decoration-none text-dark" @click="showView('/mi-perfil')">
                            <div>
                                <img class="img-menu-fixed" src="/img/icons/user-profile-menu.svg" alt="">
                            </div>
                            <p class="ms-3 mb-0" :class="isActive('/mi-perfil') == true ? 'text-title-bat text-indigo': 'text-dark text-bat'" @click="setActive('/mi-perfil')">
                                Perfil
                            </p>
                        </a>
                    </div>
                    <div class="d-flex align-items-center mb-4 item-submenu-mobile" :class="{ 'active' : this.route_view == '/novedades'}">
                        <a class="d-flex aling-items-center text-decoration-none text-dark" @click="showView('/novedades')" >
                            <div>
                                <img class="img-menu-fixed" src="/img/icons/informa2-new.svg" alt="">
                            </div>
                            <p class="ms-3 mb-0" :class="isActive('/novedades') == true ? 'text-title-bat text-indigo': 'text-dark text-bat'" @click="setActive('/novedades')">
                                Informados
                            </p>
                        </a>
                    </div>

                    <div class="d-flex align-items-center mb-4 item-close-mobile" :class="{ 'active': closeSession }">
                        <div action="/logout" method="post" class="d-flex align-items-center">
                            <div>
                                <img class="img-menu-fixed" src="/img/icons/cerrar-sesion-menu.svg" alt="">
                            </div>
                            <button class="ms-2 fs-7 text-bat mb-0 bg-transparent border-0" @click="logout()">
                                Cerrar sesión
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- slecet pdvs mobile-->
        <div class="d-block d-xl-none">
            <div class="menu-extendido" :class="{ 'active': pdvMobile }" ref="menuExtendido">
                <div class="container py-3">
                    <div class="d-flex justify-content-center mb-3" @click="pdvMobile = false">
                        <img src="/img/icons/arrow-down-grey.svg" alt="">
                    </div>
                    <div v-for="pdv in pdvs_web_ordering" :key="pdv.id" class="d-flex align-items-center mb-4 item-submenu-mobile" @click="handleCommand(pdv.id)">

                        <div class="col-12 pdv-item-mobile">
                            <div class="pdv-header-mobile">
                                <span class="pdv-name-mobile">
                                  {{ truncateText(formatName(pdv.name_pdv), 35) }}
                                </span>
                                <img
                                    v-if="pdv.id === selectedPdv"
                                    src="/img-version2/icons/staff/tick-circle.svg"
                                    alt="selected"
                                    class="pdv-tick-mobile"
                                />
                            </div>

                            <div class="pdv-address-mobile">
                                <img src="/img-version2/icons/staff/location.svg" alt="location" />
                                {{ truncateText(pdv.address_pdv, 35) }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Widget Carrito de Compras -->
        <shopping-cart-header :shopCartShow="shopCartShow" @toggleShopCart="toggleShopCart" :products_cart="products_cart" :media_netcommerce="media_netcommerce"></shopping-cart-header>
        <el-dialog :visible.sync="showSeasonModal" :width="$mq === 'sm' ? '95%' : 'md' ? '35%' : '20%'"
                   :close-on-press-escape="true" :close-on-click-modal="true" :show-close="true" append-to-body>
            <div v-if="activeSeason != null">
                <season :season_id="activeSeason.id" :staff_segments="staff_segments" :client_segment="client_segment"

                ></season>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { EventBus } from './../../app';
export default {
    props:{
        client_segment: {
            type: Number,
            default: 0,
        },
        media_netcommerce: {
            default: "",
        },
        products_cart:{
            default: [],
        },
        segments_show_pse: {
            default: [],
        },
        sellers_logo: {
            default: [],
        },
        segments_show_web_ordering: {
            default: [],
        },
        staff_segments: {
            default: [],
        },
        client_pdv_select: {
            default: null,
        }
    },
    data() {
        return {
            menuMobileActive : false,
            shopCartShow: false,
            activeLink: '/',
            subMenuDesktopActive: false,
            showNotification: false,
            route_view: '',
            element_route: null,
            preRedirect: false,
            closeSession: false,
            userPoints: 0,
            loading: 0,
            activeSeason: null,
            activeLapse: '',
            seasonStreak: '',
            pdvs_web_ordering: [],
            showRedDotRequest: 0,
            lapses: [],
            lapse_active: null,
            showSeasonModal: false,
            resolution: null,
            pdvMobile: false,
            selectedPdv: null,
        }
    },
    mounted(){
        this.getUserPoints()
        EventBus.$on('refresh-points', function (data) {
            this.getUserPoints()
        }.bind(this));
        this.getActiveSeason();
        this.getPDVsWithToken();
        this.loadPDVsWithUsersHeader();
        this.resolution = this.$mq;
        EventBus.$on('refresh-request', function (data) {
            this.loadPDVsWithUsersHeader();
        }.bind(this));
        EventBus.$on('change-select-pdv', function (select_pdv) {
            this.selectedPdv = select_pdv.select_pdv;
        }.bind(this));
        if(this.selectedPdv === null){
            this.selectedPdv = this.client_pdv_select;
        }
    },
    computed: {

        getSeasonImage() {
            if (!this.activeLapse) return '';

            if (this.activeLapse === 'in_progress') {
                return '/img-version2/icons/season/header-orange-rocket.svg';
            } else if (this.activeLapse === 'in_coming') {
                return '/img-version2/icons/season/header-gray-rocket.svg';
            } else if (this.activeLapse === 'completed') {
                return '/img-version2/icons/season/header-green-rocket.svg';
            } else {
                return '';
            }
        },
        getStaffSeasonImage() {
            if (!this.activeLapse) return '';
            if(this.seasonStreak !== 'lose'){
                if(this.activeLapse === 'completed'){
                    return '/img-version2/icons/season-staff/season-won.gif';
                }else{
                    return '/img-version2/icons/season-staff/season-current.gif';
                }
            }else{
                return '/img-version2/icons/season-staff/gray-flame.png';
            }
        },
        isStaffUser() {
            return this.staff_segments.includes(this.client_segment);
        }
    },
    methods: {
        activarMenu(){
            this.menuMobileActive = !this.menuMobileActive;
            return this.menuMobileActive;
        },
        activarShopCart(){
            this.toggleShopCart();
        },
        toggleShopCart() {
            this.shopCartShow = !this.shopCartShow;
            return this.shopCartShow;
        },
        setActive: function(url) {
            this.activeLink = url;
        },
        isActive: function(url) {
            return window.location.pathname.startsWith(url);
        },
        toggleSubMenu(){
            this.subMenuDesktopActive = !this.subMenuDesktopActive;
            return this.subMenuDesktopActive;
        },
        logout(){
            this.closeSession = true;
            axios.post('/logout', {})
                .then(
                    ({data}) => {
                        window.location.href = "/login";
                    })
        },
        buscarSegmento(client_segment) {
            for (let i = 0; i < this.sellers_logo.length; i++) {
                if (this.sellers_logo[i].includes(client_segment)) {
                    return true;
                }
            }
            return false;
        },
        showView(view){
            this.route_view = view;
            window.location.href = view;
            if(view === '/pedidos'){
                axios.post('/trackingLog', {
                    logName: 'makeAnOrder',
                    log: 'Entered to place an order',
                }).then(
                    ({data}) => {
                        //window.location.href = "/pedido";
                    })
            }
        },
        getUserPoints(){
            this.loading++
            axios.get(`/get-user-points`)
                .then(({data}) => {
                    this.userPoints = data.points
                    this.loading--
                })
        },

        getActiveSeason() {
            this.loading++
            axios.get(`/get-active-season`)
                .then(({ data }) => {
                    this.activeSeason = data.season;
                    this.activeLapse = data.active_lapse;
                    this.seasonStreak = data.season_streak;
                    this.lapses = data.season?.lapses;
                    if(data.season?.lapses){
                        this.getLapseActiveStaff();
                    }
                    this.loading--
                })
        },
        goToRetos() {
            window.location.href = '/retos'
        },
        goToStaff() {
            window.location.href = '/get-pdvs-request-manager'
        },

        handleCommand(command) {
            this.changeSelectedPDV(command);
        },

        getPDVsWithToken() {
            this.loading++;
            axios.get('/get-pdvs-with-token-wo')
                .then(({ data }) => {
                    this.pdvs_web_ordering = Object.values(data.pdvs).map(pdv => pdv);
                    this.loading--;
                })
                .catch(error => {
                    this.loading--;
                });
        },

        changeSelectedPDV(pdvId) {
            this.loading++;

            axios.post('/change-selected-pdv', { pdv_id: pdvId })
                .then(response => {
                    if (response.status === 200) {
                        location.assign("/pedidos");
                    }
                })
                .catch(error => {
                    console.error('Error al cambiar el PDV seleccionado:', error);
                    this.loading--;
                });
        },
        formatName(name) {
            let nameParts = name.split(' ').map(part => {
                return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
            });

            return nameParts.join(' ');
        },
        loadPDVsWithUsersHeader() {
            this.loading++;
            axios.get(`/get-pdvs-with-users-request?cache=1`)
                .then(({ data }) => {
                    this.showRedDotRequest = data.request_staff_count;
                    this.loading--;
                })
                .catch(error => {
                    console.error("Error al cargar los PDVs con usuarios:", error);
                    this.loading--;
                });
        },
        getLapseActiveStaff(){
            if(this.lapses.length > 0){
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                this.lapses.forEach((lapse, index) => {
                    const start = new Date(lapse.start_date);
                    const end = new Date(lapse.end_date);

                    start.setHours(0, 0, 0, 0);
                    end.setHours(0, 0, 0, 0);

                    if (today >= start && today <= end) {
                        this.lapse_active = index + 1;
                    }
                })
            }
        },
        goToCanjea() {
            window.location.href = '/catalogo'
        },
        truncateText(text, maxLength) {
            if (!text) return 'Sin Dirección'
            return text.length > maxLength ? text.substring(0, maxLength) + '...' : text
        },
    },
    }
</script>
